import React, { FC, useEffect } from 'react';
import { FieldRenderProps } from 'react-final-form';
import TextField from '../TextField';
import { scrollToViewById } from 'src/modules/shared/helpers/scroll';

const TextFieldAdapter: FC<FieldRenderProps<string, HTMLElement>> = ({
  input: { name, onChange, value, ...restInput },
  meta,
  ...rest
}) => {
  const showError = !meta.valid && meta.error && meta.submitFailed;

  useEffect(() => {
    if (!showError) return;
    scrollToViewById(name, { block: 'end' });
  }, [name, showError]);

  return (
    <TextField
      {...rest}
      id={name}
      name={name}
      helperText={showError ? meta.error || meta.submitError : undefined}
      error={showError}
      inputProps={restInput}
      onChange={onChange}
      value={value}
      autoComplete="off"
    />
  );
};

export default TextFieldAdapter;
